import styled from 'styled-components';

const VisitorSectionWrapper = styled.section`
  padding: 80px 0;
  display: flex;
  align-items: center;
  position: relative;
  @media (max-width: 990px) {
    padding: 60px 0 60px 0;
  }
  @media (max-width: 767px) {
    display: block;
  }
  .dashboardWrapper {
    width: 100%;
  }
`;

const SectionObject = styled.div`
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 767px) {
    width: 100%;
    position: relative;
    height: auto;
    top: auto;
    left: auto;
  }
  img {
    max-width: 93%;
    height: auto;
  }
  .objectWrapper {
    position: relative;
    .dashboardWrapper {
      position: absolute;
      top: 4vw;
      left: 0;
    }
  }
`;

export { SectionObject };

export default VisitorSectionWrapper;
